import {dateToISOString, localDateToUTCDate, ISOStringToDate, UTCDateToLocalDate} from '@elements/date-utils';
import {loadFlatPickr} from '@elements/datepicker';
import throwError from '@elements/throw-error';
import {getPrefixedDataSet} from "@elements/data-set-utils";
import {onFind} from "@elements/init-modules-in-scope";
import {findIn, on} from "@elements/dom-utils";

const defaultSelectors = {
    base: '.js-date-input',
    input: '.js-date-input__input',
    output: '.js-date-input__output',
    openDatepicker: '.js-date-input__open-datepicker',
};

const defaultOptions = {
    placeholderDate: '1970-10-20T00:00:00',
    mode: "single",
    showMonths: 1,
    disableMobile: true,
    appendAltTime: true
};

export function init(options = defaultOptions, selectors = defaultSelectors, scope= document.body) {
    onFind(selectors.base, function (baseElement) {
        console.log(baseElement);
        createDateInput(
            baseElement,
            {...defaultOptions, ...options},
            {...defaultSelectors, ...selectors}
        );
    }, scope);
}

export function createDateInput(baseElement, options, selectors){

    return loadFlatPickr().then(function () {

        let input = findIn(selectors.input,baseElement);
        let output = findIn(selectors.output,baseElement);
        let openDatepicker = findIn(selectors.openDatepicker,baseElement);

        let elementOptions = {
            locale: _config.lang,
            // formatDate: dateObj => dateObj.toLocaleDateString(_config.lang),

            // Info: mit einer eigenen Funktion, weil formateDate + allowInput in kombi einen bug hat
            dateFormat: getLocaleDateFormat(_config.lang),
            onChange: (selectedDates, dateStr, inst) => {
                if (selectedDates.length > 0) {
                    output.value = dateToISOString(localDateToUTCDate(selectedDates[0]), options.appendAltTime);
                } else {
                    output.value = input.value;
                }
            },
            onClose: (selectedDates, dateStr, inst) => {
                if (selectedDates.length > 0) {
                    output.value = dateToISOString(localDateToUTCDate(selectedDates[0]), options.appendAltTime);
                } else {
                    output.value = input.value;
                }
            },
            allowInput:true,
            clickOpens: false,
            ...options,
            ...transformDataOptions(getPrefixedDataSet('date-input', baseElement))
        };

        let datepicker = input.flatpickr(elementOptions);

        if (elementOptions.placeholderDate !== false && elementOptions.placeholderDate !== 'false'){
            input.setAttribute('placeholder', datepicker.formatDate(ISOStringToDate(elementOptions.placeholderDate), getLocaleDateFormat(_config.lang) ));
        }

        //set initial values & placeholder
        if (output.value) {
            let date = ISOStringToDate(output.value);
            window.ttdate = date;
            if (date instanceof Date && !isNaN(date.getMonth())) { // check if valid date
                datepicker.setDate(UTCDateToLocalDate(date), false, getLocaleDateFormat(_config.lang))
            } else {
                throwError(`${output.value} is not a valid date. Please use the following format: 1970-01-01T00:00:00`, output);
            }
        }

        on('click', () => {
            datepicker.open();
        }, openDatepicker);

    });
}


function transformDataOptions(options) {
    options = {...options};

    if (options.minDate && typeof options.minDate === 'string') {
        options.minDate = UTCDateToLocalDate(ISOStringToDate(options.minDate));
    }

    if (options.maxDate && typeof options.maxDate === 'string') {
        options.maxDate = UTCDateToLocalDate(ISOStringToDate(options.maxDate));
    }

    return options;
}

function getLocaleDateFormat(locale){
    let format = 'm/d/Y';

    if (locale === 'de'){
        format = 'd.m.Y';
    }else if(locale === 'fr'){
        format = 'd/m/Y';
    }else if(locale === 'it'){
        format = 'd/m/Y';
    }else if(locale === 'es'){
        format = 'd/m/Y';
    }else if(locale === 'en'){
        format = 'm/d/Y';
    }

    return format
}